//     This code was generated by a Reinforced.Typings tool. 
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export interface IIdeasRequestDto
{
	itemsPerPage: number;
	pageNumber: number;
	searchPhrase?: string;
	sortBy?: IdeaListSortingType;
	sortDesc?: boolean;
	spaceIds?: string;
	regionIds?: string;
	departmentIds?: string;
	groupIds?: string;
	categoryIds?: string;
	ideaTypeIds?: string;
	stateIds?: string;
	stepsIds?: string;
}
export interface IIdeaDto
{
	ideaId: number;
	spaceId: number;
	title: string;
	imageLink: string;
	creationDate: string;
	modifiedDate: string;
	noOfVisits: number;
	noOfComments: number;
	ideaType: string;
	category: string;
	state: string;
	stateHexColor: string;
	spaceName: string;
	regions: string[];
	valueDeterminate: number;
	group: string;
	department: string;
	accessLevel: string;
	votingScore: string;
	titleHighlight: any;
	snippetHighlight: any;
}
export interface IPagingInfoDto
{
	totalItemsCount: number;
	pageNumber: number;
}
export interface IPagedResultDto<T>
{
	data: T[];
	paging: IPagingInfoDto;
}
export interface IIdeaListAllMetadataDto
{
	listViewModes: ISelectListEnumItemDto<IdeaListViewMode>[];
	sortings: ISelectListEnumItemDto<IdeaListSortingType>[];
	dataItems: ISelectListEnumItemDto<IdeaListDataItemType>[];
	filters: IIdeaListFilterItemDto[];
}
export interface IIdeaListFilterItemDto
{
	type: IdeaListFilterType;
	text: string;
	uiType: IdeaListFilterUiType;
	selectListItems: ISelectListItemDto[];
	selectListItemsWithSpaceIds: ISelectListItemsWithSpaceIdDto[];
}
export interface IIdeaListSettingsDto
{
	listViewMode: IdeaListViewMode;
	sortingTypes: IdeaListSortingType[];
	filterTypes: IdeaListFilterType[];
}
export interface IIdeaListSettingsAllMetadataDto
{
	allMetadata: IIdeaListAllMetadataDto;
}
export interface IIdeaListSpaceRequestSettingsDto extends IIdeaListSettingsDto
{
	listViewMode: IdeaListViewMode;
	sortingTypes: IdeaListSortingType[];
	filterTypes: IdeaListFilterType[];
	spaceSpecificSettings: IIdeaListSpaceSpecificSettingsDto;
}
export interface IIdeaListSpaceResponseSettingsDto extends IIdeaListSettingsDto, IIdeaListSettingsAllMetadataDto
{
	listViewMode: IdeaListViewMode;
	sortingTypes: IdeaListSortingType[];
	filterTypes: IdeaListFilterType[];
	spaceSpecificSettings: IIdeaListSpaceSpecificSettingsDto;
	allMetadata: IIdeaListAllMetadataDto;
}
export interface IIdeaListGlobalRequestSettingsDto extends IIdeaListSettingsDto
{
	listViewMode: IdeaListViewMode;
	sortingTypes: IdeaListSortingType[];
	filterTypes: IdeaListFilterType[];
}
export interface IIdeaListGlobalResponseSettingsDto extends IIdeaListSettingsDto, IIdeaListSettingsAllMetadataDto
{
	listViewMode: IdeaListViewMode;
	sortingTypes: IdeaListSortingType[];
	filterTypes: IdeaListFilterType[];
	allSpaceSpecificSettings: { [key:number]: IIdeaListSpaceSpecificSettingsDto };
	allMetadata: IIdeaListAllMetadataDto;
}
export interface IIdeaListSpaceSpecificSettingsDto
{
	dataItemTypes: IdeaListDataItemType[];
}
export interface ISelectListEnumItemDto<TEnumId>
{
	value: TEnumId;
	text: string;
}
export interface ISelectListItemDto
{
	id: string;
	text: string;
}
export interface ISelectListItemsWithSpaceIdDto
{
	spaceId: number;
	selectListItems: ISelectListItemDto[];
}
export enum IdeaListDataItemType { 
	Title = "Title", 
	Image = "Image", 
	Id = "Id", 
	CreationDate = "CreationDate", 
	ModifiedDate = "ModifiedDate", 
	Visits = "Visits", 
	Comments = "Comments", 
	Type = "Type", 
	Category = "Category", 
	State = "State", 
	Access = "Access", 
	Space = "Space", 
	Region = "Region", 
	Group = "Group", 
	Department = "Department", 
	VotingScore = "VotingScore"
}
export enum IdeaListFilterType { 
	Category = "Category", 
	IdeaType = "IdeaType", 
	State = "State", 
	Region = "Region", 
	Group = "Group", 
	Department = "Department", 
	Space = "Space", 
	CreationDate = "CreationDate"
}
export enum IdeaListFilterUiType { 
	SelectItems = "SelectItems", 
	SelectItemsWithSpaceId = "SelectItemsWithSpaceId", 
	DateRange = "DateRange"
}
export enum IdeaListViewMode { 
	StandardTiles = "StandardTiles", 
	SmallTiles = "SmallTiles", 
	ClassicList = "ClassicList"
}
export enum IdeaListSortingType { 
	CreationDate = "CreationDate", 
	ModifiedDate = "ModifiedDate", 
	State = "State", 
	Step = "Step", 
	Visits = "Visits", 
	Comments = "Comments", 
	Votes = "Votes", 
	VotingScore = "VotingScore"
}
